var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7191_173127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15078 6.49556C3.48018 6.8797 3.48019 7.84686 4.15078 8.231L11.5029 12.4425C11.8108 12.6189 12.1891 12.6189 12.497 12.4425L19.8491 8.231C20.5197 7.84686 20.5197 6.8797 19.8491 6.49556L12.497 2.28405C12.1891 2.10767 11.8108 2.10767 11.5029 2.28405L4.15078 6.49556Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8986 9.37823L19.9754 10.5679C20.6167 10.9353 20.6517 11.8473 20.0405 12.2627L12.562 17.3452C12.2228 17.5758 11.7771 17.5758 11.4379 17.3452L3.95942 12.2627C3.34818 11.8473 3.38318 10.9353 4.02446 10.5679L6.10132 9.37823",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8986 14.015L19.9754 15.2046C20.6167 15.572 20.6517 16.484 20.0405 16.8994L12.562 21.9819C12.2228 22.2125 11.7771 22.2125 11.4379 21.9819L3.95942 16.8994C3.34818 16.484 3.38318 15.572 4.02446 15.2046L6.10132 14.015",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7191_173127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersIcon);
export default __webpack_public_path__ + "static/media/Layers Icon.c17b4f5b3538afe5eef56715392233eb.svg";
export { ForwardRef as ReactComponent };